import React from "react";

export const Diagnosis04: React.FC = () => {
  return (
    <div className="diagnosis04-section">
      <div className="moreinfo-container">
        <div className="moreinfo-content">
          <div className="moreinfo-left">
            <div className="moreinfo-image-container">
              <img
                src="img/diagnosis4.png"
                className="moreinfo-image"
                alt="Laparoscopía"
              />
            </div>
          </div>
          
          <div className="moreinfo-right">
          <p className="moreinfo-text">
              • La <span className="moreinfo-highlight-blue diagnosis02-underline">laparoscopía</span> es un tipo de cirugía mínimamente 
              invasiva en la cual se hacen entre 3 y 4 incisiones habitualmente y se introduce una cámara pequeña en tu abdomen. <br />
              Este es el último paso a realizarse en casos en que la sintomatología no mejoren con tratamientos analgésicos y/o hormonales o haya
              lesiones que estén comprometiendo el correcto funcionamiento de diversos órganos.
            </p>
            
            <p className="moreinfo-text">
              Si se llega a la cirugía, es importante que se aproveche esa instancia para tratar la endometriosis y por eso <span className="moreinfo-highlight-blue">es 
              clave que te la realice alguien que sepa de la patología y esté en condiciones de extirpar las lesiones que se encuentren.</span> <br />
              Algunas muestras de esas lesiones se sacan como biopsias y se mandan a estudiar a los laboratorios de anatomía patológica para que 
              observen a nivel microscópico si efectivamente se trata de endometriosis o de alguna patología similar.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};